import { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import 'pages/createShop/createShop.scss';
import { useParams } from 'react-router-dom';

import { IStore2 } from 'store/types';
import ShopPage from '../shopPage/ShopPage';
import ProfilePage from '../profilePage/ProfilePage';
import { getUserPage } from 'store/profile/ProfileActions';
import 'components/layout/content.scss';
import { WithContent } from 'components/layout/WithContent';
import StoresPage from '../storesPage/StoresPage';
import { ProfileSelector } from 'store/profile/ProfileSelector';
import { IUserPage, UserPageOptions } from 'types';
import ShopPageSkeleton from '../shopPage/skeleton/ShopPageSkeleton';

const UserPage: FC<IUserPage> = ({ selectedPageOption, getUserProfile }) => {
  const params = useParams();

  const { userId } = params;

  useEffect(() => {
    if (userId) {
      getUserProfile({ userId });
    }
  }, [userId]);

  if (selectedPageOption === UserPageOptions.Shop) {
    return WithContent(ShopPage)();
  }

  if (selectedPageOption === UserPageOptions.SearchResults) {
    return WithContent(StoresPage)();
  }

  if (selectedPageOption === UserPageOptions.Profile) {
    return WithContent(ProfilePage)();
  }

  return WithContent(ShopPageSkeleton)();
};

const mapStateToProps = (state: IStore2) => {
  const selectedPageOption = ProfileSelector.userPageTypeSelector(state);

  return { selectedPageOption };
};

const mapDispatchToProps = {
  getUserProfile: getUserPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);
